import { EmploymentStatusEnum } from '@/enums/EmploymentStatus.enum'

const userGroupsEnum = Object.freeze({
  ADMIN: 'admin',
  BROKER: 'broker',
  SUPER_BROKER: 'superbroker',
  CLIENT: 'clients',
  SUBSCRIBER: 'subscribers',
  NEWSIGNUP: 'newsignups',
})

export const isUserBroker = (groups) => groups.includes(userGroupsEnum.BROKER)
export const isUserClient = (groups) => groups.includes(userGroupsEnum.CLIENT)
export const isUserAdmin = (groups) => groups.includes(userGroupsEnum.ADMIN)
export const isUserSubscriber = (groups) =>
  groups.includes(userGroupsEnum.SUBSCRIBER)
export const isUserNewSignup = (groups) =>
  groups.includes(userGroupsEnum.NEWSIGNUP)
export const isUserSuperBroker = (groups) =>
  groups.includes(userGroupsEnum.SUPER_BROKER)

/**
 *
 * @param {EmploymentStatusEnum} employmentStatus
 * @returns {boolean} Boolean value that indicates if person is employed or not
 */
export const isUserEmployed = (employmentStatus) => {
  return (
    employmentStatus === EmploymentStatusEnum.EMPLOYED ||
    employmentStatus === EmploymentStatusEnum.SELF_EMPLOYED
  )
}
